// @flow

import { type Card } from './types';

export function getNumber(card: Card): string {
  return card.cardNumber;
}
